import { TApi } from './types';
import { auth } from './auth';
import { dashboard } from './dashboard';
import { invoices } from './invoices';
import { orders } from './orders';
import { refunds } from './refunds';
import { ordersSync } from './ordersSync';
import { user } from './user';
import { reports } from './reports';
import { vatCorrections } from './vatCorrections';
import { paymentMethods } from './paymentMethods';
import { payments } from './payments';
import { transactions } from './transactions';
import { pricing } from './pricing';
import { shipments } from './shipments';
import { gpsr } from './gpsr';
import { eudr } from './eudr';
import { euDdp } from './euDdp';
import { publicAttachment } from './publicAttachment';
import { emExports } from './emExports';
import { ppwr } from './ppwr';
import { shopifyApps } from './shopifyApps';

const api: TApi = {
	auth,
	user,
	dashboard,
	orders,
	refunds,
	ordersSync,
	invoices,
	reports,
	vatCorrections,
	paymentMethods,
	payments,
	transactions,
	pricing,
	shipments,
	gpsr,
	eudr,
	euDdp,
	publicAttachment,
	emExports,
	ppwr,
	shopifyApps,
};

export { api };
